<template>
  <div>
    <label class="form-label" for="payment-select">
      {{ $t('common.paymentTypes.titleOne') }}
    </label>
    <TomSelect
      v-model="componentValue.payment"
      :options="{
        create: false,
        placeholder: $t('common.paymentTypes.selectOne')
      }"
      class="w-full"
    >
      <option
        v-for="paymentType in paymentTypes"
        :value="paymentType"
        :key="paymentType"
      >
        {{ $t('common.paymentTypes.' + paymentType.toLowerCase()) }}
      </option>
    </TomSelect>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'

export default defineComponent({
  data() {
    return {
      paymentTypes: [
        'CASH',
        'CARD',
        'LOYALTY_POINTS',
        'GASTRO_VOUCHER',
        'GASTRO_CARD'
      ]
    }
  },

  mounted() {
    this.$emit('update:payment', {
      payment: 'CASH'
    })
  },

  props: {
    payment: {
      type: Object,
      default: () => {}
    }
  },

  emits: ['update:payment'],

  setup(props, { emit }) {
    const componentValue = computed({
      get: () => props.payment,
      set: value => emit('update:payment', value)
    })

    return {
      componentValue
    }
  }
})
</script>
